import DescriptionIcon from "@mui/icons-material/Description";
import { BaseDetailModal } from "./BaseDetailModal";

export function EmployeeMemoModal(props) {
  return (
    <BaseDetailModal
      {...props}
      title={props.title || "Employee Memo"}
      sectionLabel="Message"
      icon={DescriptionIcon}
      iconBgColor="bg-blue-50"
      iconColor="text-blue-600"
      // ─── PATCHED: pass isCc badge down to BaseDetailModal ─────────────────
      isCc={props.isCc ?? false}
      // ─────────────────────────────────────────────────────────────────────
    />
  );
}